<style lang="less">
@import "./login.less";
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录太仓市人力资源市场智能求职系统" :bordered="false">
        <div class="form-con">
          <login-form :secoundAuth=secoundAuth @on-success-valid="handleSubmit"></login-form>
<!--          <p class="login-tip">支持 本地 e-mail LDAP登录</p>-->
        </div>
      </Card>
    </div>
    <Modal v-model="modalVisible"  :title="modalTitle" :loading=true :footer-hide=true :mask-closable=false>
      <register-form v-if="!mfa" :mail="mail" :username='username' @on-submit-success="handleRegisterSubmit"></register-form>
      <m-f-a  v-else :mfa="mfa" :mail="mail" ></m-f-a>
    </Modal>
  </div>
</template>

<script>
import { LoginForm, RegisterForm } from '_c/login-form'
import { mapActions } from 'vuex'
export default {
  components: {
    LoginForm,
    RegisterForm
  },
  data () {
    return {
      secoundAuth: false,
      modalVisible: false,
      modalTitle: '',
      mail: '',
      username: '',
      mfa: ''
    }
  },

  methods: {
    ...mapActions(['handleLogin', 'handleRegister']),
    handleSubmit ({ username, password, dynamic }) {
      this.handleLogin({ username, password, dynamic }).then(res => {
        if (res.code === 0) {
          this.$Message.success(`${res.msg}`)
          // this.secoundAuth = true
          sessionStorage.setItem('sbid', res.sbid)
          // console.log(sessionStorage.getItem('sbid'))
          console.log(res)
          this.$router.push({
            name: this.$config.homeName
          })
        } else if (res.code === 1) {
          // 这里弹出二次认证
          this.secoundAuth = true
          this.$Message.success(`${res.msg}`)
        } else if (res.code === -3) {
          this.mail = res.email ? res.email : username
          this.username = res.username ? res.username : username.split('@')[0]
          this.$Message.success({
            content: `${res.msg}`,
            duration: 5,
            closable: true
          })
          this.modalVisible = true
          this.modalTitle = '注册用户'
          // 邮箱认证通过，请根据邮箱完善用户信息
        } else {
          this.$Message.error({
            content: `${res.msg}`,
            duration: 5,
            closable: true
          })
        }
      })
    },
    handleRegisterSubmit (data) {
      this.handleRegister(JSON.stringify(data)).then(res => {
        if (res.code === 0) {
          this.modalTitle = '动态密钥，非常重要'
          this.mfa = res.mfa.trim()
        } else {
          this.$Message.error({
            content: `${res.msg}`,
            duration: 3,
            closable: true
          })
          this.$router.push({ name: 'login' })
        }
      })
    },
    IEVersion () {
      var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
      var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
        reIE.test(userAgent)
        var fIEVersion = parseFloat(RegExp['$1'])
        if (fIEVersion == 7) {
          return 7
        } else if (fIEVersion == 8) {
          return 8
        } else if (fIEVersion == 9) {
          return 9
        } else if (fIEVersion == 10) {
          return 10
        } else {
          return 6// IE版本<=7
        }
      } else if (isEdge) {
        return 'edge'// edge
      } else if (isIE11) {
        return 11 // IE11
      } else {
        return -1// 不是ie浏览器
      }
    },
    openGoogle () {
      if (this.IEVersion() == -1) {
        return false
      }
      try {
        var osh = new ActiveXObject('WScript.Shell')
        var p_app_path = osh.RegRead('HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\App Paths\\chrome.exe\\')
        var oShell = new ActiveXObject('Shell.Application')
        var website = 'http://**********/' // 项目实际地址
        oShell.ShellExecute(p_app_path, website, '', 'open', '1')
        window.location.href = 'http://********/tips2.html' // 服务器更目录放置的展示页面
      } catch (e) {
        // var ele = document.getElementsByName('error')[0]
        // ele.style.display = 'block'
        window.location.href = 'http://**********/tips.html' // 服务器更目录放置的展示页面
      }
    }
  },
  mounted () {
    // this.openGoogle()
  }
}
</script>

<style>
</style>
